import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { AUTH } from '../constants/testIds';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.email)) {
      setError('Ongeldig e-mailadres.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }

    if (formData.password.length < 6) {
      setError('Wachtwoord moet minimaal 6 tekens bevatten');
      return;
    }

    setLoading(true);

    const result = await register(
      formData.name,
      formData.email,
      formData.password,
      formData.phone
    );

    if (result.success) {
      navigate('/account');
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 flex items-center justify-center bg-surface">
      <div className="max-w-md w-full px-6 py-12">
        <div className="bg-card border border-border rounded-sm p-8">
          <div className="text-center mb-6">
            <h1 className="text-3xl font-serif font-bold text-primary mb-2">Account Aanmaken</h1>
            <p className="text-muted-foreground text-sm">Maak een account om online af te spreken</p>
          </div>
          <div className="bg-[#c5a059]/10 border border-[#c5a059]/40 rounded-sm p-4 mb-6 text-xs space-y-1" data-testid="register-benefits">
            <p className="font-serif font-bold text-[#0d3b25] mb-1">Waarom een account?</p>
            <p>✓ Bekijk uw <strong>volledige afspraakgeschiedenis</strong></p>
            <p>✓ Snellere check-out — geen contactgegevens meer invullen</p>
            <p>✓ Krijg <strong>vroegtijdige toegang</strong> tot Bingo aanbiedingen</p>
            <p>✓ Loyalty-punten (binnenkort beschikbaar)</p>
          </div>

          {error && (
            <div
              className="bg-destructive/10 border border-destructive/30 text-destructive rounded-sm p-3 mb-6 text-sm"
              data-testid="register-error"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4" data-testid={AUTH.registerForm}>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">Naam</label>
              <Input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                placeholder="Uw naam"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">Email</label>
              <Input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                placeholder="uw@email.com"
                data-testid={AUTH.emailInput}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">
                Telefoon (optioneel)
              </label>
              <Input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                placeholder="+32 XXX XX XX XX"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">Wachtwoord</label>
              <Input
                type="password"
                required
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                placeholder="••••••••"
                data-testid={AUTH.passwordInput}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">
                Bevestig Wachtwoord
              </label>
              <Input
                type="password"
                required
                value={formData.confirmPassword}
                onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                placeholder="••••••••"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 button-hover"
              data-testid={AUTH.submitBtn}
            >
              {loading ? 'Account Aanmaken...' : 'Registreren'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-muted-foreground">
              Heeft u al een account?{' '}
              <Link to="/login" className="text-primary font-medium hover:underline">
                Log in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
